module.exports = "/_next/static/images/help-bg-714e97a85b02c313b6014f49695a8aac.svg";